var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTagUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.06 21.95-1.71-1.69c-.42-.42-1-.65-1.59-.65H6c-2.07 0-3.75-1.67-3.75-3.72V4.97c0-2.05 1.68-3.72 3.75-3.72h12c2.07 0 3.75 1.67 3.75 3.72v10.91c0 2.05-1.68 3.72-3.75 3.72h-.76a2.3 2.3 0 0 0-1.59.65l-1.71 1.69c-.53.54-1.24.81-1.94.81s-1.41-.27-1.94-.8zM3.75 4.97v10.91c0 1.23 1.01 2.22 2.25 2.22h.76c.99 0 1.95.4 2.65 1.09l1.71 1.69c.49.48 1.28.48 1.77 0l1.71-1.69c.7-.69 1.66-1.09 2.65-1.09H18c1.24 0 2.25-1 2.25-2.22V4.97c0-1.23-1.01-2.22-2.25-2.22H6c-1.24 0-2.25 1-2.25 2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.7h-.1A2.681 2.681 0 0 1 9.3 7c0-1.49 1.21-2.7 2.7-2.7a2.702 2.702 0 0 1 .09 5.4H12zM10.8 7c0 .65.51 1.18 1.15 1.2 0-.01.06-.01.13 0 .63-.04 1.12-.56 1.12-1.2 0-.66-.54-1.2-1.2-1.2-.66 0-1.2.54-1.2 1.2zM8.83 15.81c-.84-.56-1.33-1.37-1.33-2.23 0-.86.48-1.68 1.33-2.24 1.78-1.18 4.56-1.18 6.33 0 .84.56 1.33 1.38 1.33 2.23 0 .86-.48 1.67-1.33 2.24-.88.6-2.02.89-3.16.89-1.14 0-2.28-.3-3.17-.89zM9 13.58c0 .35.24.7.66.99 1.27.85 3.4.85 4.67 0 .43-.29.67-.64.66-.99 0-.35-.24-.7-.66-.99-1.26-.85-3.4-.85-4.67 0-.43.29-.66.64-.66.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTagUser);
export default __webpack_public_path__ + "static/media/vuesax-outline-tag-user.ee4583422a1843df2f94b7d79fd66ea8.svg";
export { ForwardRef as ReactComponent };